import { Pipe, PipeTransform } from '@angular/core';
import { prettyPrintMinutes } from '../utilities/prettyPrintMinutes';

@Pipe({
  name: 'prettyPrintMinutes',
})
export class PrettyPrintMinutesPipe implements PipeTransform {
  public transform(minutes: number): string {
    return prettyPrintMinutes(minutes);
  }
}
